import React, { useState, useEffect } from "react";
import StorefrontTitle from "../shared/storefront-title.component";
import CommonPaymentSuccessIcon from "../../assets/img/CommonPaymentSuccess.svg";
import Settings from "../../services/settings.service";
import DownloadApps from "../shared/DownloadApps";
import Storage from "../../services/storage.service";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import SimDeactivationService from "../../services/sim-deactivation.service";
import SimDeactivationStepper from "./stepper";
import Helpers from "../../helpers/shared.helper";
import FirebaseAnalytics from "../../services/analytics.service";

const PaymentSuccessSimDeactivation = (props) => {
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
    idNumber: "",
    idType: "",
    contact: "",
    IBAN: "",
    reason: "",
  });
  const appDownloadInfo = Translation.keys["scr_3.3.3_app_download_info"];

  useEffect(() => {
    const firePayInfo = Storage.get("firePayInfo", true);
    if(firePayInfo) {
      const firePayObj = JSON.parse(firePayInfo);
      if(firePayObj?.type === "sim_deactivation") {
        try {
          const findVat = () => {
            let vat_percentage = JSON.parse(Storage.get("business", true))[
              "vat_percentage"
            ] || 0;
            return vat_percentage;
          }
          let firebase_param = {
            payment_status: 1,
            amount: firePayObj?.amt || 0,
            currency: Settings?.currency || "SR",
            tax: findVat() || 0,
            item_category: "closing_bill"
          }
          FirebaseAnalytics.closing_pay_bill(firebase_param)
        } catch (error) {
          // Do Nothing
        }
      }
    }
  }, [])

  const redirectToSuspend = () => {
    if(formData) {
        setLoader(true);
        let countryCode = Helpers.getCountryCodePO() || "";
        let contactNumber = formData.contact;
        let contact_phone = `${countryCode}${contactNumber?.replace(/^0+/, '')}`;
        let data = {
            id_number: formData.idNumber,
            id_type: formData.idType,
            contact_phone: contact_phone,
            iban: formData.IBAN,
            reason: formData.reason 
        }
        SimDeactivationService.CreateTerminationTicket(data)
        .then(() =>{
            setLoader(false);
            props.history.push({
              pathname: '/sim-deactivation/suspended',
              state: { formData: formData }
            });
        })
        .catch(() => {
            setLoader(true);
        })
    }
  }

  useEffect(() => {
    const getFormData = Storage.get("simDeactivationData", true);
    if(getFormData) {
      setFormData(JSON.parse(getFormData));
    }
    const stepsDetails = {
        step1: {
            // Number
            // Prepaid & Postpaid
          status: "isDone",
        },
        step2: {
            // OTP
            // Postpaid Only
          status: "isDone",
        },
        step3: {
            // Absher
            // PrePaid Only
          status: "isDone",
        },
        step4: {
            // Payment
            // Postpaid Only
          status: "isDone",
        },
        step5: {
            // Confirmation
            // Prepaid & Postpaid
          status: "isDone",
        }
    };
    Storage.set("act_step_detail", stepsDetails);
  }, [])
  
  return (
    <>
      {loader ? <SpinnerTimeLoader /> :
      <>
        <div className="storefront-two-col-pg">
            <div className="stm-topup-info-container bill-payment-success-failed">
            <div className="success-img">
                <img src={CommonPaymentSuccessIcon} alt="" />
            </div>
            <div className="bill-payment-pay-info-container">
                <StorefrontTitle 
                    title={Translation.keys["stm_sim_deactivation_pay_comp_heading"]}
                    desc={`${Translation.keys["stm_sim_deactivation_pay_comp_desc1"]} ${formData.phone} ${Translation.keys["stm_sim_deactivation_pay_comp_desc2"]}`}
                />
                <p className="additional-pay-info">{formData.phone}{" "}{Translation.keys["stm_sim_deactivation_pay_comp_desc3"]}</p>
                <p className="additional-pay-info">{Translation.keys["stm_sim_deactivation_pay_comp_desc4"]}</p>
            </div>
            <div className="topup-field-wrapper">
                <div className="topup-btn-section">
                <button
                    className="storefront-button"
                    type="button"
                    onClick={() => { redirectToSuspend() }}
                >
                    {Translation.keys["stf_close"]}
                </button>
                </div>
            </div>
            <DownloadApps
                info={appDownloadInfo}
                classes={"download-apps"}
                google_play_link={Settings.google_play_link}
                app_store_link={Settings.app_store_link}
                huawei_store_link={Settings.huawei_store_link}
            />
            </div>
            <SimDeactivationStepper />
        </div>
    </>
    }
    </>
  );
};

export default PaymentSuccessSimDeactivation;
